import { createContext, useState } from 'react';

type ShowDrawerContextValue = {
  opened: boolean;
  setOpened: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ShowDrawerContext = createContext<ShowDrawerContextValue>({
  opened: false,
  setOpened: () => {},
});

export const ShowDrawerProvider: React.FC = ({ children }) => {
  const [opened, setOpened] = useState(false);

  return (
    <ShowDrawerContext.Provider value={{ opened, setOpened }}>
      {children}
    </ShowDrawerContext.Provider>
  );
};
